import type { PostFetchAllUnitsParams, UnitFiltersDTO, FetchUnitResponse } from "src/api/models";
import {
  getFetchUnit,
  postFetchAllUnits,
  getFetchUnitsByOrganisation,
  postSyncUnits,
} from "src/api/queries/order-portal-bff";
import { useNotification } from "src/composables/useNotification";
import type { PaginationParams } from "src/composables/ticket-entities/types";

export interface SyncUnitsResult {
  errors: string[];
  success: boolean;

  statistics: {
    total_synced: number;
    created: number;
    updated: number;
    failed: number;
    skipped: number;
  }
}

export function useUnitService() {
  const { showSuccess, showError } = useNotification();

  async function fetchUnit(unitId: string) {
    try {
      const response = await getFetchUnit(unitId);
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchUnits(params?: UnitFiltersDTO, pagination?: PaginationParams) {
    try {
      const response = await postFetchAllUnits(params ?? {}, {
        limit: pagination?.limit ?? 50,
        page: pagination?.page ?? 1
      });
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchUnitsByOrganisation(organisationId: string): Promise<FetchUnitResponse[]> {
    try {
      const response = await getFetchUnitsByOrganisation(organisationId);
      // API returns array directly, not wrapped in { data: [] }
      return Array.isArray(response) ? response : (response.data || []);
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function synchroniseUnitsInBackend(): Promise<SyncUnitsResult> {
    try {
      const result = await postSyncUnits() as unknown as SyncUnitsResult;
      return result;
    } catch (error) {
      throw error;
    }
  }

  return {
    fetchUnit,
    fetchUnits,
    fetchUnitsByOrganisation,
    synchroniseUnitsInBackend,
  };
}


